export default {
  'company_summary_report_pdf.title': 'Company Summary Report',
  'company_summary_report_pdf.subtitle':
    'Prepared for {{companyDisplayName}} on {{reportDate}}',
  'company_summary_report_pdf.filters_applied.title': 'Filters Applied:',
  'company_summary_report_pdf.average_company_reliability_score.chart.title':
    'Average Company Reliability Score',
  'company_summary_report_pdf.company_detected_risks.chart.title':
    'Company Risks Over Time',
  'company_summary_report_pdf.services_list.no_data.message':
    'No service data available',
  'company_summary_report_pdf.services_list.owned_by.label':
    'Owned By {{owner}}'
}
